export default __webpack_public_path__ + "static/4-3_Lense_Specifications-7c720360648449bb47572ec26c7706bb.webp";